import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'ddc-track-event';
import { setClassNames } from '@ddc/classnames-js';
import { useLabels, useRequestData } from 'wsm-common-data';

const controlClassnames = setClassNames(['ddc-icon', 'ddc-icon-size-xlarge']);

const MiniGridPager = ({ page, pageCount, onPageChange }) => {
	const labels = useLabels();
	const { widgetName, windowId } = useRequestData();

	if (pageCount <= 1) {
		return null;
	}

	const prevLabel = labels.get('PREVIOUS_VEHICLE');
	const nextLabel = labels.get('NEXT_VEHICLE');
	const isFirst = page === 0;
	const isLast = page >= pageCount - 1;

	// "Go to next page (2)": says where the arrow goes. The end arrows are
	// disabled, so they have no target page to name.
	const prevAriaLabel = labels.get('GO_TO_PREVIOUS_PAGE');
	const nextAriaLabel = labels.get('GO_TO_NEXT_PAGE');

	const go = (nextPage, element, elementCTA, result) => {
		onPageChange(nextPage);
		trackEvent(widgetName, windowId, {
			action: 'clicked',
			element,
			elementCTA,
			result
		});
	};

	// aria-disabled (not `disabled`) keeps the button focusable, so focus is not
	// dropped to the document when the shopper activates the last/first page.
	return (
		<nav
			aria-label={labels.get('PAGE_NAVIGATION')}
			className="mini-grid-pager d-flex justify-content-center mt-4"
		>
			<button
				type="button"
				aria-disabled={isFirst}
				aria-label={
					isFirst ? prevAriaLabel : `${prevAriaLabel} (${page})`
				}
				className="previous mx-2 btn-carousel position-relative slider-control-container slider-control-container-left"
				onClick={() => {
					if (isFirst) return;
					go(
						page - 1,
						'Prev models page arrow',
						prevLabel,
						'Showed previous models'
					);
				}}
			>
				<span className="btn-carousel-inner">
					<i
						className={`${controlClassnames} ddc-icon-skinny-arrow-left d-block`}
						aria-hidden="true"
					/>
				</span>
			</button>
			<button
				type="button"
				aria-disabled={isLast}
				aria-label={
					isLast ? nextAriaLabel : `${nextAriaLabel} (${page + 2})`
				}
				className="next mx-2 btn-carousel position-relative slider-control-container slider-control-container-right"
				onClick={() => {
					if (isLast) return;
					go(
						page + 1,
						'Next models page arrow',
						nextLabel,
						'Showed next models'
					);
				}}
			>
				<span className="btn-carousel-inner">
					<i
						className={`${controlClassnames} ddc-icon-skinny-arrow-right d-block`}
						aria-hidden="true"
					/>
				</span>
			</button>
		</nav>
	);
};

MiniGridPager.propTypes = {
	page: PropTypes.number.isRequired,
	pageCount: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired
};

export default MiniGridPager;
